module.exports = __webpack_public_path__ + "img/图片.f7a2a4ff.webp";